export default __webpack_public_path__ + "assets/icons/chevronDown.68351b90.svg";